import Icon from '../components/Icon.vue'

Icon.register({
  carrot: {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M298.2 156.6c61.7 30.1 87.3 104.5 57.2 166.2-12.6 25.8-33.1 45.4-57.1 57.1l-102 49.8-57-57c-6.2-6.2-16.3-6.2-22.6 0s-6.3 16.4 0 22.6l49.2 49.2-133.6 65.2c-11.1 5.4-24.6 0.8-30-10.3-3.1-6.4-2.9-13.7 0-19.7l128.1-262.7 50.2 50.2c3.1 3.1 7.2 4.7 11.3 4.7 4.1 0 8.2-1.6 11.3-4.7 6.3-6.2 6.3-16.3 0-22.6l-55.2-55.2c35.7-43.3 97.5-58.5 150.2-32.8zM390.3 121.7c40.7-19.5 88.8-9.4 121.7 30.3-41.6 50.3-107.5 52.5-151.9 7.9l-8-8c-44.6-44.4-42.4-110.2 7.9-151.9 39.7 32.9 49.8 81 30.3 121.7z'
      }
    ]
  }
})
